import { createContext, useState, useContext } from "react";

export const PxoPageContext   = createContext();
export const usePxoPage       = () => useContext(PxoPageContext);

export const PxoPageProvider  = ({ children }) => {

    const [horizonTypes,            setHorizonTypes             ] = useState([])

    const [selectedHorizonTypeId,   setSelectedHorizonTypeId    ] = useState(1)
    const [selectedDate,            setSelectedDate             ] = useState(undefined)
    const [selectedDateType,        setSelectedDateType         ] = useState("default")
    
    const [pxoId,                   setPxoId                    ] = useState(null)
    
    const [isFormPxoOpen,           setIsFormPxoOpen            ] = useState(false)
    const [isModalDemandOpen,       setModalDemandOpen          ] = useState(false)

    const [updatePxoTables,          setUpdatePxoTables         ] = useState(false)
    const [horizonOfPlanFormat,      setHorizonOfPlanFormat     ] = useState()


    const [isPxoHiddenRowsModalOpen, setPxoHiddenRowsModalOpen ] = useState(false)

    const [pxoTableOciosidade,          setPxoTableOciosidade       ] = useState({})

    const [produtividadeMedianColumn,       setProdutividadeMedianColumn  ] = useState(null)
    const [descargaMedianColumn,            setDescargaMedianColumn       ] = useState(null)

    const [ updateDemandSection,            setUpdateDemandSection        ] = useState(false)

    const [ updateProdutividadeTable ,      setUpdateProdutividadeTable       ] = useState(false) 
    const [ updateDescargaTable,            setUpdateDescargaTable            ] = useState(false) 
    const [ updateOciosidadeCalculations,   setUpdateOciosidadeCalculations   ] = useState(false) 
    
    const handleUpdateProdutividadeTable        = () => setUpdateProdutividadeTable(!updateProdutividadeTable)
    const handleUpdateOciosidadeCalculations    = () => setUpdateOciosidadeCalculations(!updateOciosidadeCalculations)    
    const handleUpdateDescargaTable             = () => setUpdateDescargaTable(!updateDescargaTable)


    const [ notFoundTables, setNotFoundTables ] = useState(false)

    const [ isModalDemandTableOpen, setIsModalDemandTableOpen   ] = useState(false)
    const [ selectedDemandTableEdit, setSelectedDemandTableEdit ] = useState(null)


    const __handleSelectedHorizonTypeId = id => {
          
        setSelectedHorizonTypeId(id)    
        const selectedType = horizonTypes.find(type => type.id === id);   
        setSelectedDateType(selectedType.ownerHorizonOfPlan.dateInputFilterFormat)    
    
    }

 

    const value = {

        selectedHorizonTypeId,
        handleSelectedHorizonTypeId: (id) => __handleSelectedHorizonTypeId(id),

        selectedDate,
        setSelectedDate,
        
        selectedDateType,
        setSelectedDateType,
        
        horizonTypes,
        setHorizonTypes,

        isFormPxoOpen,
        setIsFormPxoOpen,

        isModalDemandOpen,
        setModalDemandOpen,

        updatePxoTables,
        handleUpdatePxoTables: () => setUpdatePxoTables(!updatePxoTables),

        pxoId,                   
        setPxoId,

        horizonOfPlanFormat,      
        setHorizonOfPlanFormat,

        pxoTableOciosidade,
        setDescargaMedianColumn,
        setProdutividadeMedianColumn,

        produtividadeMedianColumn, 
        descargaMedianColumn,

        isPxoHiddenRowsModalOpen, 
        setPxoHiddenRowsModalOpen,

        setPxoTableOciosidade,

        updateProdutividadeTable, 
        handleUpdateProdutividadeTable,

        notFoundTables, 
        setNotFoundTables,

        handleUpdateOciosidadeCalculations, 
        updateOciosidadeCalculations,

        updateDemandSection,            
        handleUpdateDemandSection: () => setUpdateDemandSection(!updateDemandSection),


        updateDescargaTable, handleUpdateDescargaTable,
        
        isModalDemandTableOpen, setIsModalDemandTableOpen,
        selectedDemandTableEdit, setSelectedDemandTableEdit
    }

    return (
        <PxoPageContext.Provider value={value}>
            {children}
        </PxoPageContext.Provider>
    );

}

export const usePxoPageContext = () => useContext(PxoPageContext)